// 飞行记录
export default {
    flyrecirdusermanage: '飞行记录',
    Flighttime: '飞行时段',
    starttime: '开始日期',
    to: '至',
    endtime: '结束日期',
    taketime: '起飞时间',
    landtime: '降落时间',
    Durflytime: '飞行时长',
    total: '共计',
    records: '条记录',
    totaltime: '总时长',
    errmes: '错误信息',
    surefly: '一切正常可以起飞',
    dspeed: '倍速',
    flymode: '飞行模式',
    nextroute: '下一个航点',
    nowposition: '当前位置',
    pitch: '俯仰',
    rool: '滚转',
    high: '高度',
    speed: '速度',
    play: '播放',
    total2: '全部',
    collection: '收藏',
    remarks: '备注',
    VP: '电压/电量',
    flyingHeight: '飞行高度',
    positioningStatus: '定位状态',
    NS: '卫星数量',
    rtk: 'RTK',
    voltage: '电压',
    power: '电量',
    time: '时间',
}